import { ParameterType } from '@/study-search/enums';
import { FilterKey } from '@studyportals/search-filters/server-side';

import { IIndexation } from '../../../interfaces';
import { SingleValueFilter } from '../SingleValueFilter';

export class KeywordWhereFilter extends SingleValueFilter implements IIndexation {
	public constructor() {
		super(FilterKey.KEYWORD_WHERE, ParameterType.KEYWORD_WHERE, [], false, false);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1;
	}
}
